const getSelectors = storeName => {
    const getStore = state => (storeName ? state[storeName] : state) || {};
    const getDistrictsByCity = (state, city) => getStore(state).districtsRelations[city] || [];
    const getCityReferredToCurrentDistricts = state =>
        getStore(state).cityReferredToCurrentDistricts || null;
    const getNeighborhoodsByDistrict = (state, district) =>
        getStore(state).neighborhoodsRelations[district] || [];
    const getDistrictReferredToCurrentNeighborhoods = state =>
        getStore(state).districtReferredToCurrentNeighborhoods || null;
    return {
        getDistrictsByCity,
        getCityReferredToCurrentDistricts,
        getNeighborhoodsByDistrict,
        getDistrictReferredToCurrentNeighborhoods,
    };
};

export default getSelectors;
